export const parsePriceNumber = (value: unknown): number => {
  if (typeof value === "number") {
    return Number.isFinite(value) ? value : 0;
  }

  if (typeof value === "string") {
    const parsed = Number(value.replace(/[\s\u00A0]/g, "").replace(",", "."));
    return Number.isFinite(parsed) ? parsed : 0;
  }

  return 0;
};

export const getDiscountPercent = (
  currentPrice: unknown,
  originalPrice: unknown,
): number | null => {
  const current = parsePriceNumber(currentPrice);
  const original = parsePriceNumber(originalPrice);

  if (current <= 0 || original <= 0 || original <= current) {
    return null;
  }

  const percent = Math.round(((original - current) / original) * 100);
  return percent > 0 ? percent : null;
};

export const getPriceBadgeLabel = (priceGroup: unknown): string => {
  if (typeof priceGroup !== "string") {
    return "";
  }

  const normalized = priceGroup.replace(/\s+/g, " ").trim().toLowerCase();
  return normalized === "акция в руб" ? "Акция!" : "";
};
